<template>
  <div class="cancel_panel ms-controller">
    <el-breadcrumb separator=">" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>运单管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/common/list' }">普通运单</el-breadcrumb-item>
      <el-breadcrumb-item>协商详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="segment-outer">
      <div class="segment mt-10">
        <div class="segment-header">协商详情</div>
        <div class="segment-area pt-20 pb-20">
          <div class="pt-10">
            扣款原因
            <span class="font-orange pl-5" id="auto-0">{{ formData.consultReason }}</span>
          </div>
          <div class="pt-10">
            扣款金额
            <span class="font-orange pl-5" id="auto-1"> &#165;{{ formData.consultPay | thousands(2) }}</span>
          </div>
          <div class="pt-10">
            扣款类型
            <span class="font-orange pl-5" id="auto-2"> {{ formData.consultTypeDesc }}</span>
          </div>
          <div class="pt-10">
            扣款备注
            <span class="font-orange pl-5" id="auto-3"> {{ formData.consultOthersReason }} </span>
          </div>
        </div>
        <div class="segment-foot pl-15">
          <router-link :to="{ path: '/common/list' }">
            <el-button size="small" type="primary" id="auto-4">返回</el-button>
          </router-link>
          <el-button
            size="small"
            type="primary"
            plain
            class="ml-15"
            @click="cancelCanOrder"
            v-if="formData.companyUndoCancel"
            >取消</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/order.new.api';
import cfg from '@/assets/js/config';
export default {
  data: function () {
    return {
      formData: {},
      appCode: `${cfg.appcode}`,
      ordernumber: ''
    };
  },
  created() {
    this.ordernumber = this.$route.params.ordernumber;
    this.init();
  },
  methods: {
    init() {
      axios
        .post(api.orderConsultRecordQueryLatest, {
          orderNumber: this.ordernumber
        })
        .then(response => {
          this.formData = response.data;
        });
    },
    cancelCanOrder() {
      axios
        .post(api.orderConsultWebCancelUndo, {
          orderNumber: this.ordernumber,
          appCode: this.appCode
        })
        .then(res => {
          this.$router.push({ path: '/common/list' });
        });
    }
  }
};
</script>
